import React from "react";

import Sheldon from "@common/assets/images/ai/sheldon.png";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { ReleaseSummary, ReleaseSummaryInsight } from "@common/models/Analytics.model";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { MetricCardEmptyState } from "@main/pages/Release/views/MetricCards/MetricCardEmptyState";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import { format } from "date-fns";

import * as Styled from "./ReleaseSummaryCard.styles";

interface ReleaseSummaryCardProps extends ReleaseMetricCardBaseProps {
  summary?: ReleaseSummary | null;
  onGenerateSummaryClick: () => void;
}

const ReleaseSummaryCard = ({ style, summary, highlight, error, onGenerateSummaryClick }: ReleaseSummaryCardProps) => {
  return (
    <ReleaseMetricCard
      style={style}
      title={"Summary"}
      highlight={highlight}
      error={error}
      helperView={
        <Flex
          $alignItems="center"
          $gap={0.8}
        >
          <Paragraph p3>{summary && `${format(new Date(summary.generated_at), "d MMM yyyy")}`}</Paragraph>
          <Styled.Button onClick={onGenerateSummaryClick}>Refresh</Styled.Button>
        </Flex>
      }
      icon={Sheldon}
    >
      <Flex
        $column
        style={{ overflowY: "auto" }}
      >
        {summary ? (
          <Flex $column>
            {summary.insights.map((insight, index) => (
              <ReleaseSummaryRow
                key={index}
                number={index + 1}
                insight={insight}
              />
            ))}
            <Paragraph
              marginTop={14}
              color={vars.colors.grey30}
            >
              {summary.headline}
            </Paragraph>
          </Flex>
        ) : (
          <MetricCardEmptyState
            text={"Get a 30-second read on what happened in this release: what broke, what improved, what's still open"}
            buttonText={"Summarize release"}
            onButtonClick={onGenerateSummaryClick}
            column
          />
        )}
      </Flex>
    </ReleaseMetricCard>
  );
};

interface ReleaseSummaryRowProps {
  number: number;
  insight: ReleaseSummaryInsight;
}

const ReleaseSummaryRow = ({ number, insight }: ReleaseSummaryRowProps) => {
  return (
    <Flex>
      <Styled.Number>
        <Paragraph p3>{number.toString()}</Paragraph>
      </Styled.Number>
      <Paragraph
        color={vars.colors.grey30}
        p1
      >
        {insight.text}
      </Paragraph>
    </Flex>
  );
};

export { ReleaseSummaryCard };
